// src/utils/formatPrevSubmission.js

export const formatPrevSubmission = (prev) => {
  if (!prev || (typeof prev === 'object' && Object.keys(prev).length === 0)) {
    return 'N/A';
  }
  // If a previous submission includes course/professor info, attempt to
  // construct a readable string instead of returning raw JSON. The backend
  // may embed course and professor objects with `short_name`, `long_name` and
  // `name` fields respectively. Fallback to IDs or JSON if names are missing.

  const formatCourse = (course) => {
    if (!course) return null;
    if (typeof course === 'object') {
      if (course.short_name && course.long_name) {
        return `${course.short_name} – ${course.long_name}`;
      }
      return course.short_name || course.long_name || course.name || null;
    }
    return null;
  };

  const formatProfessor = (prof) => {
    if (!prof) return null;
    if (typeof prof === 'object') {
      return prof.name || null;
    }
    return null;
  };

  const courseStr = formatCourse(prev.course);
  const profStr = formatProfessor(prev.professor);
  if (courseStr && profStr) {
    return `${courseStr} – ${profStr}`;
  }
  if (courseStr) {
    return courseStr;
  }
  if (profStr) {
    return profStr;
  }
  if (prev.short_name && prev.long_name) {
    return `${prev.short_name} – ${prev.long_name}`;
  }
  if (prev.name) {
    return prev.name;
  }
  return JSON.stringify(prev);
};
